import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * RepairTracking - DEPRECATED
 * 
 * This page previously used /api/repairs which no longer exists.
 * All repair/maintenance functionality has been unified into the Cases system.
 * 
 * Redirects to:
 * - Tenant: /tenant/maintenance
 * - Landlord: /landlord/maintenance  
 * - Others: /landlord/my-cases
 */
const RepairTracking = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect based on user role
    if (user?.role === 'tenant') {
      navigate('/tenant/maintenance', { replace: true });
    } else if (user?.role === 'landlord') {
      navigate('/landlord/maintenance', { replace: true });
    } else {
      navigate('/landlord/my-cases', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-slate-600">Redirecting to maintenance...</p>
      </div>
    </div>
  );
};

export default RepairTracking;
